import React from 'react';
import { GridPageStripDesignType } from '../GridPageStripDesignType';
import { GridPageStripGamesDesignHorizontalMix } from '../GridPageStripGamesDesignHorizontalMix';
import { GridPageStripGamesDesignHorizontalSingleRow } from '../GridPageStripGamesDesignHorizontalSingleRow';
import { GridPageStripGamesDesignInteractiveGameCards } from '../GridPageStripGamesDesignInteractiveGameCards';
import {
    GridPageStripGamesDesignLandscapeMultiRow,
    GridPageStripGamesDesignLandscapeSingleRow,
} from '../GridPageStripGamesDesignLandscapeRows';
import { GridPageStripGamesDesignTop10 } from '../GridPageStripGamesDesignTop10';
import { GridPageStripGamesDesignWideSingleRow } from '../GridPageStripGamesDesignWideSingleRow';
import { useRenderCasinoThumbnail } from '../../../hooks/use-render-casino-thumbnail.hook';

function renderGamesStripDesign(strip, games, renderCasinoThumbnailFn) {
    const props = {
        strip,
        games,
        renderCasinoThumbnailFn,
    };

    switch (strip.designType) {
    case GridPageStripDesignType.TOP_10:
        return <GridPageStripGamesDesignTop10 {...props} />;
    case GridPageStripDesignType.HORIZONTAL_SINGLE_ROW:
        return <GridPageStripGamesDesignHorizontalSingleRow {...props} />;
    case GridPageStripDesignType.LANDSCAPE_MULTI_ROW:
        return <GridPageStripGamesDesignLandscapeMultiRow {...props} />;
    case GridPageStripDesignType.LANDSCAPE_SINGLE_ROW:
        return <GridPageStripGamesDesignLandscapeSingleRow {...props} />;
    case GridPageStripDesignType.WIDE_SINGLE_ROW:
        return <GridPageStripGamesDesignWideSingleRow {...props} />;
    case GridPageStripDesignType.HORIZONTAL_MIX:
        return <GridPageStripGamesDesignHorizontalMix {...props} />;
    case GridPageStripDesignType.INTERACTIVE_GAME_CARDS:
        return <GridPageStripGamesDesignInteractiveGameCards {...props} />;
    default:
        return null;
    }
}

export const GridPageStripGames = ({ strip, games }) => {
    const safeGames = games || [];
    const renderCasinoThumbnailFn = useRenderCasinoThumbnail();

    return (
        renderGamesStripDesign(strip, safeGames, renderCasinoThumbnailFn)
    );
};
